import React, { useState, useEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ArrowIcon, EmptyCheckboxIcon } from 'common/icons';
import ColumnVisibilityCheckbox from '../ColumnVisibilityCheckbox';

const TableVisibility = ({ columns }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const containerRef = useRef(null);

  const handleDropdownToggle = () => {
    setIsDropdownOpen(isOpen => !isOpen);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="NewBaseTable__visibility">
      <div ref={containerRef}>
        <button type="button" className="NewBaseTable__visibility__toggle-button" onClick={handleDropdownToggle}>
          <span className="NewBaseTable__visibility__toggle-button-checkbox">
            <EmptyCheckboxIcon />
          </span>
          <FormattedMessage id="justToggleColumns" />
          <ArrowIcon />
        </button>
        {isDropdownOpen && (
          <div className="NewBaseTable__visibility__dropdown-menu">
            {columns.map(column => (
              <ColumnVisibilityCheckbox
                key={column.id}
                textId={column.id}
                checked={column.getIsVisible()}
                onClick={column.getToggleVisibilityHandler()}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const MemoizedTableVisibility = memo(
  TableVisibility,
  (prev, next) => prev.tableVisibleColsKey === next.tableVisibleColsKey
);

TableVisibility.propTypes = {
  columns: PropTypes.array.isRequired,
};

export default MemoizedTableVisibility;
